var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active == 1)?_c('PurchaseList',{attrs:{"active":_vm.active,"tabList":_vm.tabList},on:{"update:active":function($event){_vm.active=$event}}}):(_vm.active == 2)?_c('PurchaseListNew',{attrs:{"active":_vm.active,"tabList":_vm.tabList},on:{"update:active":function($event){_vm.active=$event}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }